import { Button, Container, Divider, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'
import { useLoginLink } from 'services/loginLink'

import { appendSlackAltUTM } from '../appendSlackAlternativeUTM'

import css from './SlackAltCTA.module.css'

export function SlackAltCTA() {
    const { t } = useTranslation('slackalternative')
    const loginLink = useLoginLink()

    return (
        <>
            <Container width="sm" className={css.slackAltCTAContainer}>
                <Text tag="h2" size="major-xl" className={css.title}>
                    {t('ctaTitle')}
                </Text>
                <Button href={appendSlackAltUTM(loginLink)} size="large">
                    {t('ctaAction')}
                </Button>
            </Container>
            <Container className={css.slackAltDividerContainer}>
                <Divider separator />
            </Container>
        </>
    )
}
